import { createContext, useCallback, useContext, useState } from "react";

type MailReadingContextType = {
  isMailReading: boolean;
  setMailReading: (active: boolean) => void;
};

const MailReadingContext = createContext<MailReadingContextType>({
  isMailReading: false,
  setMailReading: () => {},
});

export function MailReadingProvider({ children }: { children: React.ReactNode }) {
  const [isMailReading, setIsMailReading] = useState(false);

  const setMailReading = useCallback((active: boolean) => {
    setIsMailReading(active);
  }, []);

  return (
    <MailReadingContext.Provider value={{ isMailReading, setMailReading }}>
      {children}
    </MailReadingContext.Provider>
  );
}

export function useMailReading() {
  return useContext(MailReadingContext);
}
